import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Nav, Dropdown } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../config/abilityContext';
import Icon from '../../Icons';
import useDocumentsAbility from '../../../screens/Shared/DirectoryNode/documentAbility';
import './style.scss';

const SidebarProfile = ({ closeSidebar, pathName, children, showChangePassword, showChangePin }) => {
  const ability = useAbility(AbilityContext);
  const { user, currentEmployee, currentCompany } = useSelector(state => state.auth);
  const { companyModules } = currentCompany;
  const attendanceManagement = companyModules?.includes('attendance_management');
  const talentManagement = companyModules?.includes('talent_management');
  const peopleManagement = companyModules?.includes('people_management');
  const whistleblowingChannel = companyModules?.includes('whistleblowing_channel');
  const [myProfileActive, setMyProfileActive] = useState(false);
  const [companyActive, setCompanyActive] = useState(false);
  const [myAttendanceActive, setMyAttendanceActive] = useState(false);
  const [comunicationActive, setComunicationActive] = useState(false);
  const [capacitationActive, setCapacitationActive] = useState(false);
  const [preventionActive, setPreventionActive] = useState(false);
  const [myDocumentActive, setMyDocumentActive] = useState(false);
  const [reportsActive, setReportsActive] = useState(false);
  const documentReadPermission = useDocumentsAbility();

  useEffect(() => {
    const companyDropdown = ['company', 'groupings'];
    const myProfileDropdown = ['profile', 'requests', 'organization_charts'];
    const myAsistanceDropdown = [
      'attendances',
      'attendances_hash',
      'shifts',
      'calendar',
      'legal_reports',
      'reports',
      'attendance_detail_report'
    ];
    const comunicationDropdown = ['benefits', 'importantdates', 'announcementstasks'];
    const capacitationDropdown = ['courses', 'dnc'];
    const documentDropdown = ['documents', 'document_token'];
    setCompanyActive(companyDropdown.includes(pathName));
    setMyAttendanceActive(myAsistanceDropdown.includes(pathName));
    setMyProfileActive(myProfileDropdown.includes(pathName));
    setComunicationActive(comunicationDropdown.includes(pathName));
    setCapacitationActive(capacitationDropdown.includes(pathName));
    setMyDocumentActive(documentDropdown.includes(pathName));
  }, [pathName]);

  const legalReportsMenu = [
    ability.can('index', 'AttendanceReport') ||
      ability.can('index', 'WorkdayReport') ||
      ability.can('index', 'HolidayReport') ||
      ability.can('index', 'ShiftReport') ||
      ability.can('index', 'OvertimeReport')
  ];

  const preventionMenu = [ability.can('index', 'RiskPreventionDocument') || ability.can('index', 'SupportDocument')];

  const requestsMenu = [
    ability.can('index', 'AdvancePayment'),
    ability.can('index', 'Permission'),
    ability.can('index', 'Vacation'),
    ability.can('index', 'Loan'),
    ability.can('index', 'ShiftChangeRequest'),
    ability.can('read', 'JointCommittee'),
    ability.can('read', 'Syndicate')
  ];

  const setDropdownKey = (navLink, currentStatus) => {
    switch (navLink) {
      case 'company':
        setMyProfileActive(false);
        setMyAttendanceActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(!currentStatus);
        setComunicationActive(false);
        break;
      case 'myprofile':
        setMyProfileActive(!currentStatus);
        setMyAttendanceActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        break;
      case 'myattendance':
        setMyAttendanceActive(!currentStatus);
        setMyProfileActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        setReportsActive(false);
        break;
      case 'reports':
        setReportsActive(!currentStatus);
        break;
      case 'comunication':
        setMyAttendanceActive(false);
        setMyProfileActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(!currentStatus);
        break;
      case 'capacitation':
        setMyAttendanceActive(false);
        setMyProfileActive(false);
        setCapacitationActive(!currentStatus);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        break;
      case 'culture':
        setMyAttendanceActive(false);
        setMyProfileActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        break;
      case 'mydocument':
        setMyAttendanceActive(false);
        setMyProfileActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(!currentStatus);
        setCompanyActive(false);
        setComunicationActive(false);
        break;
      case 'prevention':
        setMyAttendanceActive(false);
        setMyProfileActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        setPreventionActive(!currentStatus);
        break;
      default:
        setMyProfileActive(false);
        setMyAttendanceActive(false);
        setCapacitationActive(false);
        setMyDocumentActive(false);
        setCompanyActive(false);
        setComunicationActive(false);
        closeSidebar();
    }
  };

  const setLinkRrhh = () => {
    if (peopleManagement && ability.can('index', 'Dashboard')) {
      return '/dashboard';
    }
    return '/employees';
  };

  return (
    <div className="scroll-box">
      <Nav className="flex-column" activeKey={pathName} defaultActiveKey={pathName}>
        <div className="d-lg-none">
          {currentCompany.id && ability.can('rrhh', 'Employee') && (
            <Nav.Link eventKey="rrhh" as={Link} to={setLinkRrhh()} onClick={closeSidebar}>
              <Icon icon="people-outline" />
              <span className="link-menu position-absolute">Ir a RRHH</span>
            </Nav.Link>
          )}
        </div>
        {currentEmployee && (
          <>
            <Nav.Link eventKey="dashboard" as={Link} to="/profile/dashboard" onClick={closeSidebar}>
              <Icon icon="people-outline" />
              <span className="link-menu position-absolute">Dashboard</span>
            </Nav.Link>

            <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={companyActive}>
              <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('company', companyActive)}>
                <Icon icon="people-outline" />
                <span className="link-menu position-absolute">Empresa</span>
              </Dropdown.Toggle>
              <Dropdown.Menu show={companyActive}>
                <div className="company-effect">
                  <div className="border-line" />
                  <Dropdown.Item
                    eventKey="company"
                    active={pathName === 'company'}
                    as={Link}
                    to="/profile/company"
                    onClick={closeSidebar}
                  >
                    <span className="ml-n2 link-menu position-absolute">Ficha Empresa</span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="groupings"
                    active={pathName === 'groupings'}
                    as={Link}
                    to="/profile/groupings"
                    onClick={closeSidebar}
                  >
                    <span className="ml-n2 link-menu position-absolute">Agrupaciones</span>
                  </Dropdown.Item>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={myProfileActive}>
              <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('myprofile', myProfileActive)}>
                <Icon icon="stack" />
                <span className="link-menu position-absolute">Mi Perfil</span>
              </Dropdown.Toggle>
              <Dropdown.Menu show={myProfileActive}>
                <div className="myprofile-effect">
                  <div className="border-line" />
                  <Dropdown.Item
                    eventKey="profile"
                    active={pathName === 'profile'}
                    as={Link}
                    to="/profile"
                    onClick={closeSidebar}
                  >
                    <span className="ml-n2 link-menu position-absolute">Mi Perfil</span>
                  </Dropdown.Item>
                  {requestsMenu.some(item => item) && (
                    <Dropdown.Item
                      eventKey="requests"
                      active={pathName === 'requests'}
                      as={Link}
                      to="/profile/requests"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Mis Solicitudes</span>
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    eventKey="organization_charts"
                    as={Link}
                    active={pathName === 'organization_charts'}
                    to="/profile/organization_charts"
                    onClick={closeSidebar}
                  >
                    <span className="ml-n2 link-menu position-absolute">Organigrama</span>
                  </Dropdown.Item>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            {attendanceManagement && (
              <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={myAttendanceActive}>
                <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('myattendance', myAttendanceActive)}>
                  <Icon icon="people-outline" />
                  <span className="link-menu position-absolute">Mi Asistencia</span>
                </Dropdown.Toggle>
                <Dropdown.Menu show={myAttendanceActive}>
                  <div className="company-effect">
                    <div className="border-line" />
                    <Dropdown.Item
                      eventKey="attendances"
                      active={pathName === 'attendances'}
                      as={Link}
                      to="/profile/attendances"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Registro de Asistencia</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="attendances_hash"
                      active={pathName === 'attendances_hash'}
                      as={Link}
                      to="/profile/attendances_hash"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Búsqueda por Hash</span>
                    </Dropdown.Item>
                    {user.employeeCard.shift && (
                      <Dropdown.Item
                        eventKey="shifts"
                        active={pathName === 'shifts'}
                        as={Link}
                        to="/profile/shifts"
                        onClick={closeSidebar}
                      >
                        <span className="ml-n2 link-menu position-absolute">Mi Turno</span>
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item
                      eventKey="calendar"
                      active={pathName === 'calendar'}
                      as={Link}
                      to="/profile/calendar"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Mi Calendario</span>
                    </Dropdown.Item>
                    {legalReportsMenu[0] && (
                      <Dropdown.Item
                        eventKey="legal_reports"
                        active={pathName === 'legal_reports'}
                        as={Link}
                        to="/profile/legal_reports"
                        onClick={closeSidebar}
                      >
                        <span className="ml-n2 link-menu position-absolute">Reportes DT</span>
                      </Dropdown.Item>
                    )}
                    {ability.can('index', 'ProfileAttendanceDetailReport') && (
                      <>
                        <Dropdown.Item
                          eventKey="reports"
                          active={reportsActive}
                          onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            setReportsActive(!reportsActive);
                          }}
                        >
                          <span className="ml-n2 link-menu position-absolute">Informes</span>
                          <Icon
                            icon={reportsActive ? 'chevron-down' : 'chevron-forward'}
                            width={12}
                            className="position-absolute"
                            style={{ right: 10 }}
                          />
                        </Dropdown.Item>
                        {reportsActive && (
                          <Dropdown.Item
                            eventKey="attendance_detail_report"
                            active={pathName === 'attendance_detail_report'}
                            as={Link}
                            to="/profile/attendance_detail_report"
                            onClick={closeSidebar}
                            style={{ paddingLeft: 30 }}
                          >
                            <span className="ml-n2 link-menu position-absolute">Detalle de Asistencia</span>
                          </Dropdown.Item>
                        )}
                      </>
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}

            {peopleManagement && documentReadPermission && (
              <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={myDocumentActive}>
                <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('mydocument', myDocumentActive)}>
                  <Icon icon="folder-open-outline" />
                  <span className="link-menu position-absolute">Mis Documentos</span>
                </Dropdown.Toggle>
                <Dropdown.Menu show={myDocumentActive}>
                  <div className="company-effect">
                    <div className="border-line" />
                    <Dropdown.Item
                      eventKey="documents"
                      active={pathName === 'documents'}
                      as={Link}
                      to="/profile/documents"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Documentos</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="document_token"
                      active={pathName === 'document_token'}
                      as={Link}
                      to="/profile/document_token"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Búsqueda por Token</span>
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {peopleManagement && (
              <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={comunicationActive}>
                <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('comunication', comunicationActive)}>
                  <Icon icon="people-outline" />
                  <span className="link-menu position-absolute">Comunicación</span>
                </Dropdown.Toggle>
                <Dropdown.Menu show={comunicationActive}>
                  <div className="company-effect">
                    <div className="border-line" />
                    <Dropdown.Item
                      eventKey="benefits"
                      active={pathName === 'benefits'}
                      as={Link}
                      to="/profile/benefits"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Beneficios</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="company_announcements"
                      active={pathName === 'company_announcements'}
                      as={Link}
                      to="/profile/company_announcements"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Anuncios</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="importantdates"
                      active={pathName === 'importantdates'}
                      as={Link}
                      to="/profile/importantdates"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Fechas Destacadas</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="announcementstasks"
                      active={pathName === 'announcementstasks'}
                      as={Link}
                      to="/profile/announcementstasks"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Tareas</span>
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {talentManagement && (
              <Nav.Link
                eventKey="job_offers"
                as={Link}
                to="/profile/job_offers"
                onClick={() => {
                  setDropdownKey('default', false);
                  closeSidebar();
                }}
              >
                <Icon icon="folder-open-outline" />
                <span className="link-menu position-absolute">Vacantes Internas</span>
              </Nav.Link>
            )}
            {talentManagement && (
              <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={capacitationActive}>
                <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('capacitation', capacitationActive)}>
                  <Icon icon="people-outline" />
                  <span className="link-menu position-absolute">Capacitaciones</span>
                </Dropdown.Toggle>
                <Dropdown.Menu show={capacitationActive}>
                  <div className="company-effect">
                    <div className="border-line" />
                    <Dropdown.Item
                      eventKey="dnc"
                      active={pathName === 'dnc'}
                      as={Link}
                      to="/profile/dnc"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Programa de Capacitación</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="courses"
                      active={pathName === 'courses'}
                      as={Link}
                      to="/profile/courses"
                      onClick={closeSidebar}
                    >
                      <span className="ml-n2 link-menu position-absolute">Cursos</span>
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {peopleManagement && preventionMenu && preventionMenu.some(item => item) && (
              <Dropdown as={Nav.Item} className="no-border-radius-bottom" show={preventionActive}>
                <Dropdown.Toggle as={Nav.Link} onClick={() => setDropdownKey('prevention', preventionActive)}>
                  <Icon icon="book-outline" />
                  <span className="link-menu position-absolute">Prevención de Riesgo</span>
                </Dropdown.Toggle>
                <Dropdown.Menu show={preventionActive}>
                  <div className="prevention-effect">
                    <div className="border-line" />
                    {preventionMenu[0] && (
                      <>
                        <Dropdown.Item
                          eventKey="risk_prevention"
                          active={pathName === 'risk_prevention'}
                          as={Link}
                          to="/profile/risk_prevention"
                          onClick={closeSidebar}
                        >
                          <span className="ml-n2 link-menu position-absolute">Documentación Legal</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="supporting_documentation"
                          active={pathName === 'supporting_documentation'}
                          as={Link}
                          to="/profile/support_document"
                          onClick={closeSidebar}
                        >
                          <span className="ml-n2 link-menu position-absolute">Documentación de Apoyo</span>
                        </Dropdown.Item>
                      </>
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
            {whistleblowingChannel && (
              <Nav.Link
                eventKey="complaint"
                as={Link}
                to="/profile/complaints"
                onClick={() => {
                  setDropdownKey('default', false);
                  closeSidebar();
                }}
              >
                <Icon icon="people-outline" />
                <span className="link-menu position-absolute">Canal de Denuncias</span>
              </Nav.Link>
            )}
            <div className="d-lg-none">
              <Nav.Link
                eventKey="change_pin"
                onClick={() => {
                  closeSidebar();
                  showChangePin();
                }}
              >
                <Icon icon="pencil" />
                <div className="position-relative position-link width-fixed">
                  <span className="link-menu position-absolute">Cambiar PIN de Firma</span>
                </div>
              </Nav.Link>
              <Nav.Link
                eventKey="change_password"
                onClick={() => {
                  closeSidebar();
                  showChangePassword();
                }}
              >
                <Icon icon="settings-outline" />
                <div className="position-relative position-link width-fixed">
                  <span className="link-menu position-absolute">Cambiar Contraseña</span>
                </div>
              </Nav.Link>
              {children}
            </div>
          </>
        )}
      </Nav>
    </div>
  );
};

export default SidebarProfile;
